/* tslint:disable */

/* eslint-disable */

/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import type { AxiosInstance, AxiosPromise, RawAxiosRequestConfig } from "axios";
import globalAxios from "axios";

// @ts-ignore
import {
  BASE_PATH,
  BaseAPI,
  COLLECTION_FORMATS,
  RequestArgs,
  RequiredError,
  operationServerMap,
} from "../base";
// Some imports not used depending on template conditions
// @ts-ignore
import {
  DUMMY_BASE_URL,
  assertParamExists,
  createRequestFunction,
  serializeDataIfNeeded,
  setApiKeyToObject,
  setBasicAuthToObject,
  setBearerAuthToObject,
  setOAuthToObject,
  setSearchParams,
  toPathString,
} from "../common";
import type { Configuration } from "../configuration";
// @ts-ignore
import { ExportTimingsRequestDto } from "../models";
// @ts-ignore
import { GetHandHistoryRequest } from "../models";
// @ts-ignore
import { GetTimingsRequestDto } from "../models";
// @ts-ignore
import { MoneyFlowRequestDto } from "../models";
// @ts-ignore
import { PlayerTimingsByDurationResponseDto } from "../models";
// @ts-ignore
import { PlayerTimingsDetailedResponseDto } from "../models";
// @ts-ignore
import { PlayerTimingsResponseDto } from "../models";
// @ts-ignore
import { PlayersResultsStatisticResponseDto } from "../models";

/**
 * StatisticAnalyticControllerApi - axios parameter creator
 * @export
 */
export const StatisticAnalyticControllerApiAxiosParamCreator = function (
  configuration?: Configuration
) {
  return {
    /**
     *
     * @param {GetHandHistoryRequest} getHandHistoryRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    exportHandHistories: async (
      getHandHistoryRequest: GetHandHistoryRequest,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'getHandHistoryRequest' is not null or undefined
      assertParamExists("exportHandHistories", "getHandHistoryRequest", getHandHistoryRequest);
      const localVarPath = `/api/v2/statistic-analytic/analytics/hand_histories.zip`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: "POST", ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      localVarHeaderParameter["Content-Type"] = "application/json";

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        getHandHistoryRequest,
        localVarRequestOptions,
        configuration
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {ExportTimingsRequestDto} exportTimingsRequestDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    exportTimings: async (
      exportTimingsRequestDto: ExportTimingsRequestDto,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'exportTimingsRequestDto' is not null or undefined
      assertParamExists("exportTimings", "exportTimingsRequestDto", exportTimingsRequestDto);
      const localVarPath = `/api/v2/statistic-analytic/analytics/timings.csv`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: "POST", ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      localVarHeaderParameter["Content-Type"] = "application/json";

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        exportTimingsRequestDto,
        localVarRequestOptions,
        configuration
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {MoneyFlowRequestDto} moneyFlowRequestDto
     * @param {boolean} [vsHero]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getPlayersResultsStatistic: async (
      moneyFlowRequestDto: MoneyFlowRequestDto,
      vsHero?: boolean,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'moneyFlowRequestDto' is not null or undefined
      assertParamExists(
        "getPlayersResultsStatistic",
        "moneyFlowRequestDto",
        moneyFlowRequestDto
      );
      const localVarPath = `/api/v2/statistic-analytic/analytics/players-results-statistic`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: "POST", ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      if (vsHero !== undefined) {
        localVarQueryParameter["vsHero"] = vsHero;
      }

      localVarHeaderParameter["Content-Type"] = "application/json";

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        moneyFlowRequestDto,
        localVarRequestOptions,
        configuration
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {MoneyFlowRequestDto} moneyFlowRequestDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getPlayersTimingsByDurationStatistic: async (
      moneyFlowRequestDto: MoneyFlowRequestDto,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'moneyFlowRequestDto' is not null or undefined
      assertParamExists(
        "getPlayersTimingsByDurationStatistic",
        "moneyFlowRequestDto",
        moneyFlowRequestDto
      );
      const localVarPath = `/api/v2/statistic-analytic/analytics/players-timings-by-duration-statistic`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: "POST", ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      localVarHeaderParameter["Content-Type"] = "application/json";

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        moneyFlowRequestDto,
        localVarRequestOptions,
        configuration
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {GetTimingsRequestDto} getTimingsRequestDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getPlayersTimingsDetailed: async (
      getTimingsRequestDto: GetTimingsRequestDto,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'getTimingsRequestDto' is not null or undefined
      assertParamExists(
        "getPlayersTimingsDetailed",
        "getTimingsRequestDto",
        getTimingsRequestDto
      );
      const localVarPath = `/api/v2/statistic-analytic/analytics/players-timings-detailed-statistic`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: "POST", ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      localVarHeaderParameter["Content-Type"] = "application/json";

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        getTimingsRequestDto,
        localVarRequestOptions,
        configuration
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {MoneyFlowRequestDto} moneyFlowRequestDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getPlayersTimingsStatistic: async (
      moneyFlowRequestDto: MoneyFlowRequestDto,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'moneyFlowRequestDto' is not null or undefined
      assertParamExists(
        "getPlayersTimingsStatistic",
        "moneyFlowRequestDto",
        moneyFlowRequestDto
      );
      const localVarPath = `/api/v2/statistic-analytic/analytics/players-timings-statistic`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: "POST", ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      localVarHeaderParameter["Content-Type"] = "application/json";

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        moneyFlowRequestDto,
        localVarRequestOptions,
        configuration
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
  };
};

/**
 * StatisticAnalyticControllerApi - functional programming interface
 * @export
 */
export const StatisticAnalyticControllerApiFp = function (configuration?: Configuration) {
  const localVarAxiosParamCreator =
    StatisticAnalyticControllerApiAxiosParamCreator(configuration);
  return {
    /**
     *
     * @param {GetHandHistoryRequest} getHandHistoryRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async exportHandHistories(
      getHandHistoryRequest: GetHandHistoryRequest,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.exportHandHistories(
        getHandHistoryRequest,
        options
      );
      const index = configuration?.serverIndex ?? 0;
      const operationBasePath =
        operationServerMap["StatisticAnalyticControllerApi.exportHandHistories"]?.[index]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, operationBasePath || basePath);
    },
    /**
     *
     * @param {ExportTimingsRequestDto} exportTimingsRequestDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async exportTimings(
      exportTimingsRequestDto: ExportTimingsRequestDto,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.exportTimings(
        exportTimingsRequestDto,
        options
      );
      const index = configuration?.serverIndex ?? 0;
      const operationBasePath =
        operationServerMap["StatisticAnalyticControllerApi.exportTimings"]?.[index]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, operationBasePath || basePath);
    },
    /**
     *
     * @param {MoneyFlowRequestDto} moneyFlowRequestDto
     * @param {boolean} [vsHero]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async getPlayersResultsStatistic(
      moneyFlowRequestDto: MoneyFlowRequestDto,
      vsHero?: boolean,
      options?: RawAxiosRequestConfig
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => AxiosPromise<PlayersResultsStatisticResponseDto>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.getPlayersResultsStatistic(
        moneyFlowRequestDto,
        vsHero,
        options
      );
      const index = configuration?.serverIndex ?? 0;
      const operationBasePath =
        operationServerMap["StatisticAnalyticControllerApi.getPlayersResultsStatistic"]?.[
          index
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, operationBasePath || basePath);
    },
    /**
     *
     * @param {MoneyFlowRequestDto} moneyFlowRequestDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async getPlayersTimingsByDurationStatistic(
      moneyFlowRequestDto: MoneyFlowRequestDto,
      options?: RawAxiosRequestConfig
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => AxiosPromise<PlayerTimingsByDurationResponseDto>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.getPlayersTimingsByDurationStatistic(
          moneyFlowRequestDto,
          options
        );
      const index = configuration?.serverIndex ?? 0;
      const operationBasePath =
        operationServerMap[
          "StatisticAnalyticControllerApi.getPlayersTimingsByDurationStatistic"
        ]?.[index]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, operationBasePath || basePath);
    },
    /**
     *
     * @param {GetTimingsRequestDto} getTimingsRequestDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async getPlayersTimingsDetailed(
      getTimingsRequestDto: GetTimingsRequestDto,
      options?: RawAxiosRequestConfig
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => AxiosPromise<PlayerTimingsDetailedResponseDto>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.getPlayersTimingsDetailed(
        getTimingsRequestDto,
        options
      );
      const index = configuration?.serverIndex ?? 0;
      const operationBasePath =
        operationServerMap["StatisticAnalyticControllerApi.getPlayersTimingsDetailed"]?.[index]
          ?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, operationBasePath || basePath);
    },
    /**
     *
     * @param {MoneyFlowRequestDto} moneyFlowRequestDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async getPlayersTimingsStatistic(
      moneyFlowRequestDto: MoneyFlowRequestDto,
      options?: RawAxiosRequestConfig
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<PlayerTimingsResponseDto>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.getPlayersTimingsStatistic(
        moneyFlowRequestDto,
        options
      );
      const index = configuration?.serverIndex ?? 0;
      const operationBasePath =
        operationServerMap["StatisticAnalyticControllerApi.getPlayersTimingsStatistic"]?.[
          index
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, operationBasePath || basePath);
    },
  };
};

/**
 * StatisticAnalyticControllerApi - factory interface
 * @export
 */
export const StatisticAnalyticControllerApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance
) {
  const localVarFp = StatisticAnalyticControllerApiFp(configuration);
  return {
    /**
     *
     * @param {GetHandHistoryRequest} getHandHistoryRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    exportHandHistories(
      getHandHistoryRequest: GetHandHistoryRequest,
      options?: any
    ): AxiosPromise<object> {
      return localVarFp
        .exportHandHistories(getHandHistoryRequest, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {ExportTimingsRequestDto} exportTimingsRequestDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    exportTimings(
      exportTimingsRequestDto: ExportTimingsRequestDto,
      options?: any
    ): AxiosPromise<object> {
      return localVarFp
        .exportTimings(exportTimingsRequestDto, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {MoneyFlowRequestDto} moneyFlowRequestDto
     * @param {boolean} [vsHero]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getPlayersResultsStatistic(
      moneyFlowRequestDto: MoneyFlowRequestDto,
      vsHero?: boolean,
      options?: any
    ): AxiosPromise<PlayersResultsStatisticResponseDto> {
      return localVarFp
        .getPlayersResultsStatistic(moneyFlowRequestDto, vsHero, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {MoneyFlowRequestDto} moneyFlowRequestDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getPlayersTimingsByDurationStatistic(
      moneyFlowRequestDto: MoneyFlowRequestDto,
      options?: any
    ): AxiosPromise<PlayerTimingsByDurationResponseDto> {
      return localVarFp
        .getPlayersTimingsByDurationStatistic(moneyFlowRequestDto, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {GetTimingsRequestDto} getTimingsRequestDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getPlayersTimingsDetailed(
      getTimingsRequestDto: GetTimingsRequestDto,
      options?: any
    ): AxiosPromise<PlayerTimingsDetailedResponseDto> {
      return localVarFp
        .getPlayersTimingsDetailed(getTimingsRequestDto, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {MoneyFlowRequestDto} moneyFlowRequestDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getPlayersTimingsStatistic(
      moneyFlowRequestDto: MoneyFlowRequestDto,
      options?: any
    ): AxiosPromise<PlayerTimingsResponseDto> {
      return localVarFp
        .getPlayersTimingsStatistic(moneyFlowRequestDto, options)
        .then((request) => request(axios, basePath));
    },
  };
};

/**
 * StatisticAnalyticControllerApi - object-oriented interface
 * @export
 * @class StatisticAnalyticControllerApi
 * @extends {BaseAPI}
 */
export class StatisticAnalyticControllerApi extends BaseAPI {
  /**
   *
   * @param {GetHandHistoryRequest} getHandHistoryRequest
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof StatisticAnalyticControllerApi
   */
  public exportHandHistories(
    getHandHistoryRequest: GetHandHistoryRequest,
    options?: RawAxiosRequestConfig
  ) {
    return StatisticAnalyticControllerApiFp(this.configuration)
      .exportHandHistories(getHandHistoryRequest, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {ExportTimingsRequestDto} exportTimingsRequestDto
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof StatisticAnalyticControllerApi
   */
  public exportTimings(
    exportTimingsRequestDto: ExportTimingsRequestDto,
    options?: RawAxiosRequestConfig
  ) {
    return StatisticAnalyticControllerApiFp(this.configuration)
      .exportTimings(exportTimingsRequestDto, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {MoneyFlowRequestDto} moneyFlowRequestDto
   * @param {boolean} [vsHero]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof StatisticAnalyticControllerApi
   */
  public getPlayersResultsStatistic(
    moneyFlowRequestDto: MoneyFlowRequestDto,
    vsHero?: boolean,
    options?: RawAxiosRequestConfig
  ) {
    return StatisticAnalyticControllerApiFp(this.configuration)
      .getPlayersResultsStatistic(moneyFlowRequestDto, vsHero, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {MoneyFlowRequestDto} moneyFlowRequestDto
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof StatisticAnalyticControllerApi
   */
  public getPlayersTimingsByDurationStatistic(
    moneyFlowRequestDto: MoneyFlowRequestDto,
    options?: RawAxiosRequestConfig
  ) {
    return StatisticAnalyticControllerApiFp(this.configuration)
      .getPlayersTimingsByDurationStatistic(moneyFlowRequestDto, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {GetTimingsRequestDto} getTimingsRequestDto
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof StatisticAnalyticControllerApi
   */
  public getPlayersTimingsDetailed(
    getTimingsRequestDto: GetTimingsRequestDto,
    options?: RawAxiosRequestConfig
  ) {
    return StatisticAnalyticControllerApiFp(this.configuration)
      .getPlayersTimingsDetailed(getTimingsRequestDto, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {MoneyFlowRequestDto} moneyFlowRequestDto
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof StatisticAnalyticControllerApi
   */
  public getPlayersTimingsStatistic(
    moneyFlowRequestDto: MoneyFlowRequestDto,
    options?: RawAxiosRequestConfig
  ) {
    return StatisticAnalyticControllerApiFp(this.configuration)
      .getPlayersTimingsStatistic(moneyFlowRequestDto, options)
      .then((request) => request(this.axios, this.basePath));
  }
}
